import type { Standort_Lohnabrechnungsart } from '../../../gql/graphql';

export class Lohnabrechnungseinstellungen {
  constructor({
    beraternummer,
    lohnabrechnungsart,
    mandantennummer,
  }: {
    beraternummer?: string | null;
    lohnabrechnungsart?: Standort_Lohnabrechnungsart | null;
    mandantennummer?: string | null;
  }) {
    this.beraternummer = beraternummer;
    this.lohnabrechnungsart = lohnabrechnungsart;
    this.mandantennummer = mandantennummer;
  }

  beraternummer?: string | null;
  lohnabrechnungsart?: Standort_Lohnabrechnungsart | null;
  mandantennummer?: string | null;
}
